export default "__VITE_ASSET__DAoe6BvF__"